.modal {
    --close-button-size: 24px;

    position: fixed;
    inset: 0;
    z-index: 101;
}

.dialog {
    width: 100%;
    height: 100%;
    outline: 0;
}

.overlay {
    position: fixed;
    inset: 0;
    background-color: var(--overlay-black-56);
    z-index: 0;
}

.panel {
    position: fixed;
    top: 0;
    right: 0;
    max-width: 100vw;
    height: 100dvh;
    z-index: 1;
    display: flex;
    flex-direction: column;
}

@media (prefers-reduced-motion: no-preference) {
    .overlay {
        transition: opacity 300ms cubic-bezier(0.16, 1, 0.3, 1);
    }

    .panel {
        transition: transform 300ms cubic-bezier(0.16, 1, 0.3, 1);
    }

    .modal[data-entering] .overlay,
    .modal[data-exiting] .overlay {
        opacity: 0;
    }

    .modal[data-entering] .panel,
    .modal[data-exiting] .panel {
        transform: translateX(100%);
    }
}

.header {
    flex: 0 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid var(--gray-300);
    padding: var(--spacer-24) var(--spacer-40);
}

.title {
    font: var(--font-h-24);
    margin: 0;
    flex-grow: 1;
}

.close {
    width: var(--close-button-size);
    height: var(--close-button-size);
}

.body {
    flex: 1 1 auto;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding: var(--spacer-40);

    &:focus-visible {
        outline: var(--outline);
        outline-offset: 1px;
    }
}
